import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { watch } from '../../internal/watch.js';
import styles from './arc-menu-item.styles.js';
export default class ArcMenuItem extends LitElement {
    constructor() {
        super(...arguments);
        this.disabled = false;
    }
    firstUpdated() {
        this.setAttribute('role', 'menuitem');
    }
    handleDisabledChange() {
        this.setAttribute('aria-disabled', String(this.disabled));
    }
    render() {
        return html `
      <div
        id="main"
        class=${classMap({
            'menu-item': true,
            'menu-item--disabled': this.disabled,
        })}
      >
        <span id="prefix">
          <slot name="prefix"></slot>
        </span>
        <span id="label">
          <slot></slot>
        </span>
        <span id="suffix">
          <slot name="suffix"></slot>
        </span>
      </div>
    `;
    }
}
ArcMenuItem.tag = 'arc-menu-item';
ArcMenuItem.styles = styles;
__decorate([
    property({ type: String })
], ArcMenuItem.prototype, "value", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], ArcMenuItem.prototype, "disabled", void 0);
__decorate([
    watch('disabled')
], ArcMenuItem.prototype, "handleDisabledChange", null);
